/*
 * Copyright (c) 2026. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
 * filterregel-ongekwalificeerd-edit.component.ts
 * 31-08-2026 - Jelmer Jellema - Spin in het Web B.V.
 * Gegenereerd met Claude (AI), 31-08-2026
 * Editorcomponent voor de regel "Ongekwalificeerd personeel", die geen keuzes kent.
 */

import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FilterregelEditComponent} from './filterregel-edit.component';
import {FiltertoolPlanitemongekwalificeerdRegel} from '../../../services/filtertool/regels/filtertool-ongekwalificeerdregel';
import {FiltertoolRegelTypeNamen} from '../../../services/filtertool/filtertool-regels';
import {FilterregelActiesComponent} from './filterregel-acties.component';

/**
 * Editor voor de regel "Ongekwalificeerd personeel". Er valt niets te kiezen: de regel is altijd
 * geldig en toont alleen wat hij doet, plus de gebruikelijke acties.
 */
@Component({
    standalone: true,
    selector: 'filterregel-ongekwalificeerd-edit',
    imports: [CommonModule, FilterregelActiesComponent],
    templateUrl: './filterregel-ongekwalificeerd-edit.component.html',
    styleUrls: ['./filterregel-ongekwalificeerd-edit.component.scss', './filterregel-editors.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterregelOngekwalificeerdEditComponent extends FilterregelEditComponent<FiltertoolPlanitemongekwalificeerdRegel> {
    // Inputs (properties)
    /** De te bewerken regel. */
    @Input({required: true}) override regel!: FiltertoolPlanitemongekwalificeerdRegel;

    // Properties
    /** Mapping met label/omschrijving per regeltype voor weergave. */
    public readonly regelTypeNamen = FiltertoolRegelTypeNamen;

    // Constructor
    constructor() {
        super('debug');
    }
}
